import { useEffect, type ReactNode } from "react"

import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/hooks/use-flash"
import { useTranslation } from "react-i18next"

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  const { i18n } = useTranslation()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const locale = params.get("locale")
    if (locale) {
      i18n.changeLanguage(locale)
      localStorage.setItem("i18nextLng", locale)
      params.delete("locale")
      const newUrl = [window.location.pathname, params.toString()]
        .filter(Boolean)
        .join("?")
      window.history.replaceState({}, "", newUrl)
    }
  }, [])

  return (
    <>
      {children}
      <Toaster richColors />
    </>
  )
}
